import React, { useRef, useEffect } from "react";
import { Button, Row, Col } from 'react-bootstrap';




const SortButton = ({showSort, setShowSort, sortOptions, intl, setSort, sort, order, setOrder }) => {
  function useOutsideAlerter(ref) {
    useEffect(() => {
      function handleClickOutside(event) {
        if (ref.current && !ref.current.contains(event.target)) {
          setShowSort(false);
        }
      }
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [ref]);
  }
  const wrapperRef = useRef(null);
  useOutsideAlerter(wrapperRef);
  return (
    <div className="sort-container" id="sort-container" ref={wrapperRef}>
      <Button className={showSort ? "selected sort-btn-co" : "sort-btn-co"} onClick={() => setShowSort(!showSort)}>
        <img className="sort-icon" src="/icons/list.png" alt="sort" />
        {intl.formatMessage({ id: 'common.sort' })}
        <img className={showSort ? "chev chev-up" : "chev"} src="/icons/chev_down.png" alt="chev" />
      </Button>
      {
        showSort && <div className="options-container">
          <Row>
            {
              sortOptions.map((o, i) => (
                <Col key={i} md={6}>
                  <div className="d-flex">
                    <Button className={sort === o.value ? "selected-sort" : ''} onClick={() => setSort(o.value)}>{intl.formatMessage({ id: o.label })}</Button>
                    {
                      sort === o.value &&
                      <Button className="sort-btn" onClick={() => setOrder(order === "asc" ? "desc" : "asc")}>
                        {order === "asc" ? <i className="fas fa-sort-amount-down-alt"></i> : <i className="fas fa-sort-amount-down"></i>}
                      </Button>
                    }
                  </div>
                </Col>
              ))
            }
          </Row>
        </div>
      }
    </div>
  )
}

export default SortButton;